import React from 'react';
import BuscarDni from '../components/BuscarDni';
import Footer from '../components/Footer';
import AdsSection from '../components/adsense/AdsSection';

export default function ConsultasPage() {


  return (
    <div>
      {/* Contenido principal */}
      <div>
        <BuscarDni />       
        <AdsSection 
          layout="grid"
          title="Publicidad"
          showTitle={true}
        />
     
        
        <Footer />
      </div>
    </div>
  );
}